module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","date":"Date","rate":"Rate"},"et":{"name":"Name","date":"Date","rate":"Rate"},"ru":{"name":"Name","date":"Date","rate":"Rate"}}')
  delete Component.options._Ctor
}
